import { render, staticRenderFns } from "./CalculatorQuestionsCard.vue?vue&type=template&id=4b2c720f&"
import script from "./CalculatorQuestionsCard.vue?vue&type=script&lang=ts&"
export * from "./CalculatorQuestionsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports